import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { Router } from '@angular/router'
import { QuoteTrackingService } from '../quote-tracking.service'
import { Observable } from 'rxjs'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { SpinnerOverlayService } from '../../../../shared/components/spinner-overlay/spinner-overlay.service'

@Component({
  standalone: false,
  selector: 'vs-quote-merge-footer-line',
  templateUrl: './quote-merge-footer-line.component.html',
  styleUrls: ['./quote-merge-footer-line.component.scss'],
})
export class QuoteMergeFooterLineComponent implements OnInit {
  constructor(
    private quoteTrackingService: QuoteTrackingService,
    private router: Router,
    private spinnerOverlayService: SpinnerOverlayService,
    private globalMessageService: GlobalMessageService
  ) {}
  @Input() quotes
  @Input() dateObject
  @Output() updateQuotes = new EventEmitter<any>()
  @Output() dicardQuotes = new EventEmitter<boolean>()
  maxLength = 3
  public quoteArray$: Observable<any>
  public quoteArray
  public lineItemFlag: boolean
  public count: number
  ngOnInit(): void {}
  getMaxArray() {
    return Array(this.maxLength)
  }
  closeCard(quote, i) {
    this.quotes.splice(i, 1)
    this.updateQuotes.emit(this.quotes)
    this.quoteTrackingService.emitMergeQuote(quote.quoteId)
  }
  proceedToMerge() {
    this.count = 0
    this.lineItemFlag = false
    this.spinnerOverlayService.show()
    this.quoteTrackingService.setQuotesForMerge(this.quotes)

    for (let quoteItem of this.quotes) {
      this.quoteArray$ = this.quoteTrackingService.getQuoteDetailsFromList(
        quoteItem.quoteId,
        this.dateObject.fromDate,
        this.dateObject.toDate
      )
      this.quoteArray$.subscribe((quotes) => {
        this.spinnerOverlayService.hide()
        this.count++
        this.checkLineItems(quotes)
      })
    }
  }
  checkLineItems(quotes) {
    this.quoteArray = quotes
    let result = this.quoteArray.quoteLineDetails.filter(
      (item) => item.isOrderCreated === false //item.quoteStatus == ''
    )
    if (result.length === 0) {
      this.quotes = this.quotes.filter(
        (item) => item.quoteId !== this.quoteArray.quoteDetailsList.quoteId
      )
      this.updateQuotes.emit(this.quotes)
      this.lineItemFlag = true
      this.globalMessageService.add(
        {
          key: 'quoteTracking.quoteNotEligibleMerge',
          params: {
            quoteIdJson: this.quoteArray.quoteDetailsList.quoteId,
          },
        },
        GlobalMessageType.MSG_TYPE_ERROR,
        10000
      )
      window.scrollTo(0, 0)
    }
    if (this.count == this.quotes.length && this.lineItemFlag == false) {
      this.quoteTrackingService.setQuoteDetailsForMerge(
        this.quoteArray.quoteDetailsList
      )
      this.router.navigate(['quote-merge'], { queryParams: this.dateObject })
    }
  }
  discard() {
    this.quotes = []
    this.updateQuotes.emit(this.quotes)
    this.quoteTrackingService.setQuotesForMerge(this.quotes)
  }
}
